import { useDeleteMappingDeviceTagsMutation } from "graphqlBase/MappingDeviceTag/__generated__/deleteMappingDeviceTags";
import { GetMappingDeviceTagsDocument } from "graphqlBase/MappingDeviceTag/__generated__/getMappingDeviceTags";
import { MappingDeviceTag } from "..";

const useDeleteDeviceTags = ({ selectedDeviceIds }: { selectedDeviceIds: string[] | undefined }) => {
  const [deleteMappingDeviceTagsMutation, { loading }] = useDeleteMappingDeviceTagsMutation({
    refetchQueries: [{ query: GetMappingDeviceTagsDocument }],
  });

  const handleDeleteDeviceTags = async ({
    mappingDeviceTags,
    ids,
  }: {
    ids: string[];
    mappingDeviceTags: MappingDeviceTag[];
  }) => {
    if (!selectedDeviceIds?.length) return;
    const deleteMappingDeviceTags = ids.flatMap((id) =>
      selectedDeviceIds
        .map((currId) => {
          const index = mappingDeviceTags.findIndex((entry) => entry.deviceId === currId && entry.tagId === id);
          if (index !== -1)
            return {
              mappingDeviceTagId: mappingDeviceTags[index].id,
              deviceTagId: mappingDeviceTags[index].tagId,
            };
        })
        .filter(Boolean)
    );

    if (deleteMappingDeviceTags.length > 0) {
      await deleteMappingDeviceTagsMutation({
        variables: { ids: deleteMappingDeviceTags.map((curr) => curr?.mappingDeviceTagId) as string[] },
      });
    }
  };

  return {
    deleteDeviceTagsLoading: loading,
    handleDeleteDeviceTags,
  };
};

export default useDeleteDeviceTags;
